<template>
  <div class="upload-box">
    <el-upload
            v-if="uploadType === 'list'"
            class="upload-certificates"
            :class="{'hidden-upload-btn': fileList.length >= limit }"
            action
            :accept="accept"
            :http-request="handleUpload"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-success="handleSuccess"
            :before-remove="beforeRemove"
            :before-upload="beforeUpload"
            :limit="limit"
            :on-exceed="handleExceed"
            :file-list="fileList"
            :list-type="listType"
            :auto-upload="true"
    >
      <div class="upload-plus">
        <i class="el-icon-plus"></i>
        <p>{{flag}}</p>
      </div>

    </el-upload>
    <el-upload
            v-if="uploadType === 'avatar'"
            class="avatar-uploader"
            action
            :http-request="handleUpload"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-success="handleSuccess"
            :before-remove="beforeRemove"
            :before-upload="beforeUpload"
            :limit="limit"
            :on-exceed="handleExceed"
            :file-list="fileList"
            :show-file-list="false"
    >
      <img v-if="fileList.length > 0" :src="$common.imgPath(fileList[0].name,'100x100')" class="avatar">
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <el-upload
            v-if="uploadType === 'article'"
            class="upload-article"
            action
            :http-request="handleUpload"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-success="handleSuccess"
            :before-remove="beforeRemove"
            :before-upload="beforeUpload"
            :limit="limit"
            :on-exceed="handleExceed"
            :file-list="fileList"
            :list-type="listType"
            :auto-upload="true"
            :show-file-list="false">
            <img v-if="fileList.length > 0" :src="$common.imgPath(fileList[0].name)" class="article-img">
            <div v-else class="tips">
              <i class="el-icon-camera-solid"></i>
              <div class="el-upload__text tip-txt">添加题图</div>
            </div>
    </el-upload>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
 //import {uploads} from '../../api/uploadImg'
 import { put, signatureUrl, getFileNameUUID } from '../../utils/ali-oss'
  export default {
    name: 'Upload',
    props: {
      value: [ String ],
      tip: {
        type: String,
        default: '上传大小不能超过80M'
      },
      limit: {
        type: Number,
        default: 5
      },
      action: {
        type: String,
        default: ''
      },
      headers: {
        type: Object,
        default: () => {}
      },
      name: {
        type: String,
        default: ''
      },
      listType: {
        type: String,
        default: 'picture-card' // text / picture / picture-card
      },
      uploadType:{
        type: String,
        default: 'list' // avatar
      },
        flag:{
            type: String,
            default:'上传图片'
        },
        accept:{
            type: String,
            default:'image/*'
        }
    },
    data() {
        return {
            fileList:  [],
            dialogVisible: false,
            dialogImageUrl: ''
        }
    },
    watch:{
        fileList( val ){
            console.log( 'file changer :',val)
            this.inputFileStr()
        },
        value( val ){
            console.log('upload - data:',val)
            this.setFileList( val )
        }
    },
    mounted(){
        this.setFileList( this.value )
    },
    methods: {
        handleRemove(file, fileList) {
            console.log('on-remove', file, fileList)
            this.fileList = fileList
            this.$emit('on-remove', file, fileList)
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        /*handlePreview(file) {
          this.$emit('on-preview', file)
        },*/
        handleExceed(files, fileList) {
            this.$message.warning(`只能上传 ${this.limit} 个文件`)
        },
        beforeRemove(file, fileList) {
            // return this.$confirm(`确定移除 ${file.name}？`)
        },
        handleSuccess(response, file, fileList) {
            // this.fileList.push() = fileList
            console.log('on-success', file, fileList)
            this.$emit('on-success', file, fileList)
        },
        beforeUpload(file) {
            // 限制上传类型
            // console.log('file',file);

            const ext = ['.jpg','.jpeg','.png','.gif']
            const videoExt = ['.mp4','.wmv','.mov']
            // const fileExtensions = this.getFileName(file.name) === '.jpg' || this.getFileName(file.name) === '.png' || this.getFileName(file.name) ==='.gif'
            //限制的上限为10M
            let fileExtensions = true;
            const max10M = file.size / 1024 / 1024 < 10;
            if (this.accept=='image/*'&&ext.indexOf(this.getFileName(file.name)) === -1) {
                fileExtensions = false
                this.$message.error('上传文件类型只能是 .jpg, .png, .gif 格式!');
            }
            if(this.accept=='video/*'&&videoExt.indexOf(this.getFileName(file.name)) === -1){
                fileExtensions = false
                this.$message.error('上传文件类型只能是 .mp4, .wmv, .mov 格式!');
            }
            if (!max10M) {
                this.$message.error('上传文件大小不能超过 10MB!');
            }
            return fileExtensions && max10M;
        },
        /**
         * 自定义上传方法
         */
        handleUpload(option) {
            // 获取文件的后缀名
            let objName = getFileNameUUID()
            var obj = option.file.name
            var index = obj.lastIndexOf(".");
            obj = obj.substring(index,obj.length);
            // 生成的文件名，保留文件后缀名，进行拼接
            objName = getFileNameUUID() + this.getFileName(option.file.name)

            // 调用 ali-oss 中的方法,flieName是存放的文件夹名称，可自己定义
            let requestUrl = '';
            if(this.accept=='image/*'){
                requestUrl=`image/${objName}`
            }
            if(this.accept=='video/*'){
                requestUrl=`video/${objName}`
            }
            put(requestUrl, option.file).then(res => {
                console.log('oss puted:',res)
                if (this.uploadType === 'avatar') {
                    this.fileList = [{
                        url: res.url,
                        name: objName
                    }]
                }else{
                    this.fileList.push({
                        url: res.url,
                        name: objName
                    })
                }

                // 上传成功之后，转换真实的地址
                signatureUrl(requestUrl).then(res => {
                    console.log('oss signed:',res)
                })
            })
        },
        getFileName( fileName ){
            let fileNames = fileName.split('.');
            return '.' + fileNames[fileNames.length - 1];
        },
        setFileList( str ){
            const files = typeof str === 'string' ? str.split(',') : []
            let fileList = []
            // this.fileList = []
            // if( files.length )
            // console.log('set files :',files)

            files.forEach(v => {
                if( v ){
                    fileList.push({
                        url: this.accept=='image/*'?this.$common.imgPath(v):this.$common.videoPath(v),
                        name: v
                    })
                }
            })
            if( fileList.length > 0 ) this.fileList = fileList
        },
        inputFileStr(){
            let list = []
            this.fileList.forEach(v => {
                list.push(v.name)
            })
            // console.log('input upload:', '"' + this.value + '"' , '"'  +  list.join(',') + '"' )
            this.$emit('input', list.join(',') )
        }
    }
  }
</script>
<style lang="scss">
  .upload-box{
    display: inline-block;
    overflow: hidden;
    &+.upload-box{margin-left:50px;}
    .upload-certificates{
      float: left;

      .el-upload--picture-card{
        border:1px dashed #E4E5E5;
        width:200px;
        height:150px;
        line-height:30px;
        text-align: center;
        color:#999999;
        background-color:#ffffff;
      }
      .el-upload-list--picture-card .el-upload-list__item{
        border:1px dashed #E4E5E5;
        width:200px;
        height:150px;
        text-align: center;
        color:#999999;
        background-color:#ffffff;
      }

      .upload-plus{padding-top:30px;}
      .btn-plus{font-size:60px;color:#c9c9c9;}

    }
    .upload-article{
      background-color:#F6F6F6;
      width:100%;
      height:332px;
      text-align: center;
      position: relative;
      .tips{
        width:100px;
        height:70px;
        line-height:20px;
        position: absolute;
        top:50%;
        left:50%;
        margin-top:-35px;
        margin-left:-50px;
        i{
          color:#CACACA;
          font-size:32px;
        }
        .tip-txt{
          font-size:18px;
          padding-top:17px;
          color:#999999;
        }


      }
    }
    .avatar-uploader {
      .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      .el-upload:hover {
        border-color: #409EFF;
      }
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
    .article-img{
      width:100%;
      height:100%;
    }
    .hidden-upload-btn .el-upload--picture-card{
      display: none;
    }
  }
</style>
